import intent from './assets/intent.svg';
import leads from './assets/leads.svg';

interface MenuItem {
  icon: any;
  label: string;
  path: string;
}

const LeadsIcon = () => <img src={leads} alt="Leads" />;
const IntentIcon = () => <img src={intent} alt="Intent Signals" />;

export const menuItems: MenuItem[] = [
  // { 
  //   icon: <SlHome />,
  //   label: 'Home', 
  //   path: '/home' 
  // },
  {
    icon: LeadsIcon,
    label: 'Accounts',
    path: '/accounts'
  },
  {
    icon: IntentIcon,
    label: 'Intent Signals',
    path: '/intent-signals'
  }

];
